import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {EndpointService} from "./endpoint.service";
import {ActiveNotificationsResponse} from "../responses/notifications/ActiveNotificationsResponse";
import {map, of, shareReplay} from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private http: HttpClient) { }

  public getActiveNotifications() {
    return this.http.get<ActiveNotificationsResponse>(EndpointService.notificationEndpoint).pipe(map(response => response.responseObject));
  }
}
